import React, { createContext, useContext, useReducer } from "react";
import axios from "axios";
// import XLSX from "xlsx";
// import * as XLSX from 'xlsx/xlsx.mjs';

export const StateContext = createContext();
export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);
export const useStateValue = () => useContext(StateContext);
// const Context = React.createContext({ authenticated: false });

export const registerToken = () => {
  const code = {
    grant_type: "refresh_token",
    refresh_token: localStorage.getItem("refresh_token"),
  };
  axios({
    method: "post",
    url: "fx-auth-server/oauth/token",
    data: code,
  }).then((response) => {
    if (response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("role", response.data.role);
      localStorage.setItem(
        "customerId",
        response.data.customerId ? response.data.customerId : -1
      );
      localStorage.setItem("tokenTime", Date.now());
      localStorage.setItem("view_as_client", response.data.view_as_client);
      localStorage.setItem(
        "readonly_customer",
        response.data.readonly_customer
      );
      localStorage.setItem("refresh_token", response.data.refresh_token);
      let status = "prospect";
      if (response.data.view_as_client) status = "view_as_client";
      else {
        if (response.data.is_user_admin) {
          status = "admin";
        } else if (response.data.prospectUser) {
          if (response.data.customerId) status = "registered";
          else status = "prospect";
        } else status = "approved";
      }
      localStorage.setItem("status", status);
    }
  });
};

export const refreshToken = () => {
  //clearInterval(tokenCheck);
  if (!window.tokenCheck) {
    let requestPending = false;
    window.tokenCheck = setInterval(() => {
      if (localStorage.getItem("refresh_token")) {
        const time =
          (Date.now() - localStorage.getItem("tokenTime")) / (1000 * 60);
        if (time > 4 && !requestPending) {
          requestPending = true;
          const code = {
            grant_type: "refresh_token",
            refresh_token: localStorage.getItem("refresh_token"),
          };
          axios({
            method: "post",
            url: "fx-auth-server/oauth/token",
            data: code,
          }).then((response) => {
            if (response.data.access_token) {
              localStorage.setItem("token", response.data.access_token);
              localStorage.setItem(
                "customerId",
                response.data.customerId ? response.data.customerId : -1
              );
              localStorage.setItem("role", response.data.role);
              localStorage.setItem("tokenTime", Date.now());
              localStorage.setItem(
                "view_as_client",
                response.data.view_as_client
              );
              localStorage.setItem(
                "readonly_customer",
                response.data.readonly_customer
              );
              localStorage.setItem(
                "refresh_token",
                response.data.refresh_token
              );
              let status = "prospect";
              if (response.data.view_as_client) status = "view_as_client";
              else {
                if (response.data.is_user_admin) {
                  status = "admin";
                } else if (response.data.prospectUser) {
                  if (response.data.customerId) status = "registered";
                  else status = "prospect";
                } else status = "approved";
              }
              localStorage.setItem("status", status);
              requestPending = false;
            }
          });
        }
      }
    }, 5000);
  }
};

export const parseCurrency = (amount) => {
  if (amount && isNaN(amount) && amount.indexOf(",") !== -1) {
    let newAmount = "";
    let amountArr = amount.split(",");
    for (var k = 0; k < amountArr.length; k++) {
      // Trim the excess whitespace.
      amountArr[k] = amountArr[k].replace(/^\s*/, "").replace(/\s*$/, "");
      // Add additional code here, such as:
      newAmount = newAmount.concat(amountArr[k]);
    }
    amount = newAmount;
  }
  return amount;
};
// export const workbook2blob = (workbook) => {
//   const wopts = {
//     bookType: "xlsx",
//     bookSST: false,
//     type: "binary",
//   };
//   const wbout = XLSX.write(workbook, wopts);
//   // Convert string to ArrayBuffer
//   function s2ab(s) {
//     const buf = new ArrayBuffer(s.length);
//     const view = new Uint8Array(buf);
//     for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
//     return buf;
//   }
//   const blob = new Blob([s2ab(wbout)], {
//     type: "application/octet-stream",
//   });
//   return blob;
// };
export const formatMoney = (
  amount,
  decimalCount = 2,
  decimal = ".",
  thousands = ","
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    // console.log(e);
  }
};

export const formatDate = (dateObj) => {
  if (dateObj === null || dateObj === "") return null;

  var monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  var date = new Date(dateObj);
  date =
    date.getDate() +
    " " +
    monthNames[date.getMonth()] +
    " " +
    date.getFullYear();
  return date;
};
export const formateReportDate = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return date + "-" + month + "-" + dateObj.getFullYear();
};

export const parseDate = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return dateObj.getFullYear() + "-" + month + "-" + date;
};
export const parseDateTime = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  var today = new Date();
  var min = today.getMinutes();
  if (min < 10) {
    min = "0" + min;
  }
  var time = today.getHours() + ":" + min;

  return dateObj.getFullYear() + "-" + month + "-" + date + " " + time;
};

export const shortenDealId = (dealId) => {
  let newDealId = dealId;
  let index = dealId.lastIndexOf("-");
  if (index !== -1) {
    newDealId = dealId.substring(index + 1, dealId.length);
  }
  return newDealId;
};
export const sortArray = (arr, key, sortByAscending, dataType) => {
  let data =
    dataType === "string"
      ? sortByString(arr, key, sortByAscending)
      : dataType === "date"
      ? sortByDate(arr, key, sortByAscending)
      : dataType === "number"
      ? sortByNumber(arr, key, sortByAscending)
      : arr;
  return data;
};
export const sortByNumber = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (parseFloat(a[key]) < parseFloat(b[key])) {
      return ascending ? -1 : 1;
    } else {
      return ascending ? 1 : -1;
    }
  });
  return arr;
};
export const sortByString = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (a[key] < b[key]) {
      return ascending ? -1 : 1;
    } else {
      return ascending ? 1 : -1;
    }
  });
  return arr;
};
export const sortByDate = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (ascending) {
      return new Date(a[key]).getTime() - new Date(b[key]).getTime();
    } else {
      return new Date(b[key]).getTime() - new Date(a[key]).getTime();
    }
  });
  return arr;
};
export const formatErrString = (myJSON) => {
  // console.log(myJSON);
  var myJSONString = JSON.stringify(myJSON);
  // console.log(myJSONString);
  var myEscapedJSONString = myJSONString
    .replace(/\\n/g, "\\n")
    .replace(/\\'/g, "\\'")
    .replace(/\\"/g, '\\"')
    .replace(/\\&/g, "\\&")
    .replace(/\\r/g, "\\r")
    .replace(/\\t/g, "\\t")
    .replace(/\\b/g, "\\b")
    .replace(/\\f/g, "\\f");
  // console.log(myEscapedJSONString);
  return JSON.parse(myEscapedJSONString);
};

export const SearchTable = (tableData, keys, searchParam) => {
  let filteredData = [];
  if (tableData && tableData.length > 0) {
    filteredData = tableData.filter((row) => {
      let isExists = false;
      keys &&
        keys.forEach((key) => {
          if (typeof row[key] === "string") {
            isExists =
              isExists ||
              row[key].toLowerCase().includes(searchParam.toLowerCase());
          }
        });
      return isExists;
    });
  }
  return filteredData;
};
export const formatReportDate = (item) => {
  let dd = new Date();
  if (item) {
    // if (typeof item === "object") {
    //   return formatDate(item);
    // } else {
    return new Date(item);

    // const [year, month, day] = item.split("-");
    // const date = day + "-" + month + "-" + year;
    // return date;
    // }
  } else return "";
};
export const formatReportMoney = (item) => {
  // console.log(typeof item, item);
  let value = Number(item);
  // if (Number(value) < 0) {
  //   value = "-" + Math.abs(Number(value));
  // }
  // console.log("TYPE -  ", typeof value, item, value);
  return value ? value : "0.00";
};
export const textFormat = (text) => {
 const abc =  text?.toLowerCase()
  .split(' ')
  .map((s) => s?.charAt(0).toUpperCase() + s.substring(1))
  .join(' ');
  return abc;
}
// export { Context };
export const parseAndSetFlag = (flag) => {
  const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
 return parsedFlag;
};

//Sorting data
export const sortByProperty = (data, property, keysToCheck = []) => {
  return data
    ?.map((item) => {
      // Check if all specified keys are zero, null, or undefined
      const shouldExclude = keysToCheck.every((key) => {
        const value = item?.[key];
        return value === 0 || value === null || value === undefined;
      });

      // Return null if all specified keys have invalid values, else retain the item
      if (shouldExclude) {
        return null;
      }

      return {
        id: item?.id,
        ...item, // Spread the item to retain all properties for flexibility
      };
    })
    .filter(Boolean) // Filter out null values
    .sort((a, b) => a?.[property] - b?.[property]); // Sort by the specified property
};

export const parseDateMDY = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return  date + "-" + month + "-" + dateObj.getFullYear();
};

export const formatAmount = (amount, showSymbol = true) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "";

  const formatter = new Intl.NumberFormat("en-IN", {
    style: showSymbol ? "currency" : "decimal",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const toCamelCase = (str) => {
  return str
      ?.replace(/[_-]/g, ' ')
      ?.split(' ')
      ?.map((word) => 
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      )
      ?.join(' ');
};

export const splitIntoCustomChunks = (array, sizes) => {
  const result = [];
  let index = 0;

  for (let size of sizes) {
    result.push(array.slice(index, index + size));
    index += size;
  }

  return result;
};

export const removeUnderscores = (str) => {
  if (typeof str !== "string") return "";
  return str.replace(/_/g, " ");
}

export const formatRoleStringPretty = (str) => {
  if (typeof str !== "string") return "";
  return str
    .replace(/^role_/, "")         // remove role_
    .split("_")                    // split on underscores
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const removeAllSpaces = (value = "") => {
  return value.replace(/\s+/g, "");
};

export const sanitizeUsernameOrEmail = (value) => value.replace(/[^A-Za-z0-9@._-]/g, "");


export const handleOnlyNumber = (value, setter) => {
    const regex = /^\d*$/;
    if (value === "" || regex.test(value)) {
      setter(value);
    }
};


export const handleOnlyNumberPointerAndNegative = (value, setter) => {
     const regex = /^-?(\d+(\.\d*)?|\.\d*)$/;
      if (value === "" || value === "-" || value === "." || value === "-.") {
        setter(value);
        return;
      }
      if (regex.test(value)) {
        setter(value);
      }
};

 export const removeUnderscoresAndCapitalize = (str) => {
  const words = str?.split('_');
  const capitalizedWords = words?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1));
  const result = capitalizedWords?.join(' ');
  return result;
};

export const handleOnlyNumberAndPointer = (value, setter) => {
     const regex = /^-?(\d+(\.\d*)?|\.\d*)$/;
      if (regex.test(value) || value === "") {
        setter(value);
      }
};

export const replaceValueToCode = (value)=>{
  return (
  String(value)
    .trim()
    .toUpperCase()
    .replace(/\//g, "_")
    .replace(/[^A-Z0-9_ ]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
  )
}

export const isValidValue = (value) => {
  return value !== undefined &&
         value !== null &&
         String(value).trim() !== "";
};

export const numericRegex =  /^\d*\.?\d*$/;

export const formatDateTime = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};